import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ProjectsApiService } from 'src/services/projectsApi'
import {
  ProjectErrorResponse,
  ProjectPayload,
} from 'src/services/projectsApi/interfaces/projects.interface'

interface UseCreateProjectMutationParams {
  onSuccess?: () => void
}

const createProject = async (payload: ProjectPayload) =>
  ProjectsApiService.create(payload)

export const useCreateProjectMutation = ({
  onSuccess,
}: UseCreateProjectMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createProject,
    onError: (error: AxiosError<ProjectErrorResponse>) => {
      toast.error(
        error.response?.data?.errors?.join(', ') ||
          error.response?.data?.error ||
          'Failed to create project'
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_PROJECTS] })
      toast.success('Project created successfully')
      onSuccess?.()
    },
  })
}
